import {Component, Inject, Input, OnInit, PLATFORM_ID} from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { ProgressBarComponent } from '../../../core/components/progress-bar/progress-bar.component';
import {SubscriptionService} from '../../../core/services/subscription/subscription.service';
import {isPlatformBrowser} from '@angular/common';

@Component({
  selector: 'app-sidebar-trial',
  standalone: true,
  imports: [
    TranslocoPipe,
    ProgressBarComponent
  ],
  templateUrl: './sidebar-trial.html',
  styleUrl: './sidebar-trial.scss'
})
export class SidebarTrial implements OnInit {
  @Input() trialEndDate: string | null = null;
  public numberOfDaysLeft = 0;
  public totalTrialDays = 30;

  public constructor(
    private readonly subscriptionService: SubscriptionService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
  }

  public ngOnInit() {
    if (!this.trialEndDate) {
      return;
    }

    const now = new Date();
    const end = new Date(this.trialEndDate);
    const timeDiff = end.getTime() - now.getTime();

    // Calculate days left (minimum 0)
    const daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
    this.numberOfDaysLeft = Math.max(daysLeft, 1);
  }

  public progress(): number {
    const daysUsed = this.totalTrialDays - this.numberOfDaysLeft;
    const progressPercent = (daysUsed / this.totalTrialDays) * 100;
    return Math.min(Math.max(progressPercent, 0), 100);
  }

  public redirectToCustomerPortal(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.subscriptionService.getCustomerPortalLink().subscribe({
      next: (response) => {
        window.location.href = response.url;
      },
    });
  }
}
